let IS_PROD=true;
const server=IS_PROD?
    "https://smarteyebackend.onrender.com":
    "http://localhost:9090"
    


export default server;